// src/components/ads-admin/CompetitorsModal.jsx
import React, { useState } from "react";

export default function CompetitorsModal({
  open,
  onClose,
  primaryBrand,
  brands,
  competitors,
  onAdd,
  onRemove,
}) {
  const [selectedId, setSelectedId] = useState("");

  if (!open) return null;

  const competitorIds = new Set((competitors || []).map((c) => c.competitor_brand_id));
  const primaryId = primaryBrand ? Number(primaryBrand.id) : null;

  const available = (brands || []).filter((b) => {
    const bid = Number(b.id);
    return bid !== primaryId && !competitorIds.has(bid) && !b.is_deleted;
  });

  const handleAdd = () => {
    if (!selectedId) return;
    onAdd(Number(selectedId));
    setSelectedId("");
  };

  const overlay = {
    position: "fixed", inset: 0, zIndex: 1200,
    background: "rgba(15,23,42,0.55)",
    display: "flex", alignItems: "center", justifyContent: "center",
  };

  const modal = {
    background: "#fff", borderRadius: 16, padding: 24,
    width: "100%", maxWidth: 480,
    boxShadow: "0 24px 60px rgba(15,23,42,0.18)",
    display: "grid", gap: 16,
  };

  const rowStyle = {
    display: "flex", alignItems: "center", gap: 10,
    padding: "10px 12px",
    borderRadius: 10,
    border: "1px solid #e5e7eb",
    background: "#f8fafc",
  };

  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h3 style={{ margin: 0, fontSize: 15, fontWeight: 950, color: "#111827" }}>
            Competitors
          </h3>
          <button
            onClick={onClose}
            style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer", color: "#6b7280", lineHeight: 1 }}
          >
            ✕
          </button>
        </div>

        {/* Primary brand */}
        <div>
          <div style={{ fontSize: 11, fontWeight: 800, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 8 }}>
            Primary brand
          </div>
          <div style={{ ...rowStyle, borderColor: "#6366f1", background: "#eef2ff" }}>
            <span style={{ fontSize: 18 }}>🔵</span>
            <span style={{ fontWeight: 900, fontSize: 14, color: "#111827", flex: 1 }}>
              {primaryBrand ? `#${primaryBrand.id} — ${primaryBrand.name}` : "—"}
            </span>
            <span style={{ fontSize: 11, fontWeight: 800, color: "#6366f1", textTransform: "uppercase", letterSpacing: "0.04em" }}>
              Primary
            </span>
          </div>
        </div>

        {/* Competitor list */}
        <div>
          <div style={{ fontSize: 11, fontWeight: 800, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 8 }}>
            Competitors ({(competitors || []).length})
          </div>
          {(competitors || []).length === 0 ? (
            <div style={{ fontSize: 13, color: "#9ca3af", fontWeight: 700, padding: "8px 0" }}>
              No competitors added yet.
            </div>
          ) : (
            <div style={{ display: "grid", gap: 6 }}>
              {(competitors || []).map((c) => (
                <div key={c.competitor_brand_id} style={rowStyle}>
                  <span style={{ fontSize: 16 }}>⚔️</span>
                  <span style={{ fontWeight: 800, fontSize: 14, color: "#374151", flex: 1 }}>
                    #{c.competitor_brand_id} — {c.competitor_brand_name}
                  </span>
                  <button
                    onClick={() => onRemove(c.competitor_brand_id)}
                    style={{
                      background: "none", border: "none", cursor: "pointer",
                      color: "#dc2626", fontSize: 16, lineHeight: 1, padding: "2px 6px",
                    }}
                    title="Remove competitor"
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Add competitor */}
        {available.length > 0 && (
          <div>
            <div style={{ fontSize: 11, fontWeight: 800, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 8 }}>
              Add competitor
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <select
                value={selectedId}
                onChange={(e) => setSelectedId(e.target.value)}
                style={{
                  flex: 1, padding: "9px 12px", borderRadius: 10,
                  border: "1px solid #d1d5db", fontSize: 14, fontWeight: 700,
                  background: "#fff", color: "#111827", outline: "none",
                }}
              >
                <option value="">Select a brand…</option>
                {available.map((b) => (
                  <option key={b.id} value={String(b.id)}>
                    #{b.id} — {b.name}
                  </option>
                ))}
              </select>
              <button
                className="btn-primary"
                onClick={handleAdd}
                disabled={!selectedId}
                style={{ padding: "9px 18px", borderRadius: 10, whiteSpace: "nowrap" }}
              >
                Add
              </button>
            </div>
          </div>
        )}

        {available.length === 0 && (competitors || []).length > 0 && (
          <div style={{ fontSize: 12, color: "#9ca3af", fontWeight: 700 }}>
            All available brands are already added as competitors.
          </div>
        )}

        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button className="btn-secondary" onClick={onClose} style={{ padding: "8px 18px", borderRadius: 10 }}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
